import React, { useState } from 'react';
import './design/atlasVivo/tokens.css';
import './design/atlasVivo/Buttons.css';
import './ReplayControls.css';
import { REPLAY_EXPORT_STATE } from './replayExportState';
import { t } from './i18n';

const SPEED_OPTIONS = [
  { label: '1×', value: 1 },
  { label: '4×', value: 4 },
  { label: '12×', value: 12 },
];

export { REPLAY_EXPORT_STATE };

function exportButtonLabel(exportState) {
  switch (exportState) {
    case REPLAY_EXPORT_STATE.RECORDING:
      return 'Gravando…';
    case REPLAY_EXPORT_STATE.DONE:
      return '✓ Baixado';
    case REPLAY_EXPORT_STATE.UNSUPPORTED:
      return t('web.replay.unavailable');
    case REPLAY_EXPORT_STATE.ERROR:
      return t('action.retry');
    default:
      return t('web.replay.downloadVideo');
  }
}

export default function ReplayControls({
  cityName,
  totalEvents,
  currentIndex,
  currentDate,
  isPlaying,
  speed,
  progress,
  exportState = REPLAY_EXPORT_STATE.IDLE,
  exportError = '',
  onPlay,
  onPause,
  onSpeedChange,
  onRestart,
  onClose,
  onExport,
}) {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const exportUnsupported = exportState === REPLAY_EXPORT_STATE.UNSUPPORTED;
  const exportRecording = exportState === REPLAY_EXPORT_STATE.RECORDING;
  const exportDisabled = exportUnsupported || exportRecording || totalEvents === 0;

  return (
    <div className={`replay-overlay atlas-vivo-scope${isCollapsed ? ' replay-collapsed' : ''}`}>
      {isCollapsed ? (
        <button
          type="button"
          className="replay-expand-btn av-btn av-btn--secondary"
          onClick={() => setIsCollapsed(false)}
          title="Replay"
        >
          ▶ {cityName}
        </button>
      ) : (
        <div className="replay-panel">
          <div className="replay-header">
            <div className="replay-city-name">{cityName}</div>
            <div className="replay-header-actions">
              <button
                type="button"
                className="replay-export-btn av-btn av-btn--primary"
                onClick={onExport}
                disabled={exportDisabled}
                title={exportUnsupported ? t('web.replay.exportUnavailable') : t('web.replay.exportVideo')}
                data-export-state={exportState}
              >
                {exportButtonLabel(exportState)}
              </button>
              <button
                type="button"
                className="replay-toggle-collapse av-btn av-btn--icon"
                onClick={() => setIsCollapsed(true)}
                title="Minimizar"
              >
                ╌
              </button>
              <button
                type="button"
                className="replay-close-btn av-btn av-btn--icon"
                onClick={onClose}
                title={t('action.close')}
              >
                ×
              </button>
            </div>
          </div>

          {exportUnsupported && (
            <p className="replay-export-fallback" role="status">
              {t('web.replay.exportFallback')}
            </p>
          )}

          {exportState === REPLAY_EXPORT_STATE.DONE && !exportError && (
            <p className="replay-export-success" role="status">
              Vídeo exportado com sucesso.
            </p>
          )}

          {exportState === REPLAY_EXPORT_STATE.ERROR && exportError && (
            <p className="replay-export-error" role="alert">{exportError}</p>
          )}

          <div className="replay-progress">
            {totalEvents === 0 ? (
              <p className="replay-empty-hint">
                Nenhum evento encontrado nesta cidade. Tente importar mais dados, ampliar o período ou escolher outra cidade.
              </p>
            ) : (
              <>
                <div className="replay-progress-bar">
                  <div className="replay-progress-fill" style={{ width: `${progress}%` }} />
                </div>
                <div className="replay-progress-info">
                  <span className="replay-progress-date">
                    {currentDate ? currentDate : '--'}
                  </span>
                  <span className="replay-progress-count">
                    {currentIndex} / {totalEvents}
                  </span>
                </div>
              </>
            )}
          </div>

          <div className="replay-controls">
            <button
              type="button"
              className="replay-btn replay-restart av-btn av-btn--icon"
              onClick={onRestart}
              title="Reiniciar"
              disabled={totalEvents === 0}
            >
              ⏮
            </button>
            <button
              type="button"
              className={`replay-btn replay-play av-btn av-btn--icon${isPlaying ? ' replay-pause-active' : ''}`}
              onClick={isPlaying ? onPause : onPlay}
              title={isPlaying ? 'Pausar' : 'Continuar'}
              disabled={totalEvents === 0}
            >
              {isPlaying ? '⏸' : '▶'}
            </button>
            <div className="replay-speed-group">
              {SPEED_OPTIONS.map((opt) => (
                <button
                  key={opt.value}
                  type="button"
                  className={`replay-btn replay-speed-btn av-btn av-btn--secondary${speed === opt.value ? ' active' : ''}`}
                  onClick={() => onSpeedChange(opt.value)}
                  title={`Velocidade ${opt.label}`}
                >
                  {opt.label}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
